
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ActivityPanel } from "./Types.js";
import { map, bind, ofNullable } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { tryParse } from "../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { FSharpRef } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";

function panelKey(userId) {
    return concat("activity_bar_panel_", ...userId);
}

function chatConversationKey(userId) {
    return concat("activity_bar_chat_conversation_", ...userId);
}

function toStorageValue(panel) {
    switch (panel.tag) {
        case 1:
            return "chat";
        case 2:
            return "support";
        case 3:
            return "help";
        default:
            return "notifications";
    }
}

function ofStorageValue(value) {
    switch (value) {
        case "notifications":
            return new ActivityPanel(0, []);
        case "chat":
            return new ActivityPanel(1, []);
        case "support":
            return new ActivityPanel(2, []);
        case "help":
            return new ActivityPanel(3, []);
        default:
            return undefined;
    }
}

function read(key) {
    try {
        return ofNullable(localStorage.getItem(key));
    }
    catch (matchValue) {
        return undefined;
    }
}

function write(key, value) {
    try {
        if (value == null) {
            localStorage.removeItem(key);
        }
        else {
            const value_1 = value;
            localStorage.setItem(key, value_1);
        }
    }
    catch (matchValue) {
    }
}

export function loadPanel(userId) {
    return bind(ofStorageValue, read(panelKey(userId)));
}

export function savePanel(userId, panel) {
    write(panelKey(userId), map(toStorageValue, panel));
}

export function loadChatConversation(userId) {
    return bind((value) => {
        let matchValue;
        let outArg = "00000000-0000-0000-0000-000000000000";
        matchValue = [tryParse(value, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (matchValue[0]) {
            return matchValue[1];
        }
        else {
            return undefined;
        }
    }, read(chatConversationKey(userId)));
}

export function saveChatConversation(userId, conversationId) {
    write(chatConversationKey(userId), map((value) => value, conversationId));
}

